import { withLoyaltyStore } from "../../utils/withLoyaltyStore";

import { ReferAFriend as ReferAFriendBase } from "./ReferAFriend";

export type * from "./ReferAFriend";
export const ReferAFriend = withLoyaltyStore(ReferAFriendBase, "ReferAFriend");
